export const formatHours = (hoursDecimal) => {
  const hours = Math.floor(hoursDecimal);
  const minutesDecimal = (hoursDecimal - hours) * 60;
  const minutes = Math.floor(minutesDecimal);
  const seconds = Math.round((minutesDecimal - minutes) * 60);

  return `${hours}h ${minutes}m ${seconds}s`;
};


export const flattenedData = (jsonData) => 
  jsonData.flatMap((user, userIndex) =>
    user.dates.map((dateItem) => ({
      srNo: userIndex + 1, // optional: or compute per row
      name: user.name,
      date: dateItem.date,
      total_duration: dateItem.total_duration,
      sessions: dateItem.sessions, // keep sessions for modal
    }))
  );

